import * as types from '@/store/types';

export default {
    [types.MUTATE_NOTIFICATION_LIST]: (state, payload) => {
        state.notificationList = payload
    },
    [types.MUTATE_USER_NOTIFICATION_LIST]: (state, payload) => {
        state.notificationList = payload
    },
    [types.MUTATE_DASHBOARD_STATISTICS]: (state, payload) => {
        state.dashboard_statistics = payload
    },
    [types.MUTATE_TRACKING_SHEET]: (state, payload) => {
        state.tracking_sheet = payload
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/notification/mutations.js